import React from 'react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import type { PaymentActivePixCreditCard_query$key } from './__generated__/PaymentActivePixCreditCard_query.graphql.ts';
import { useChargePaymentMethod } from '../../../charge/useChargePaymentMethod.tsx';
import { useGraphQLType } from '../../../graphql/useGraphQLType.ts';
import type { PaymentActivePixCreditCard_charge$key } from '../creditCard/__generated__/PaymentActivePixCreditCard_charge.graphql.ts';
import PaymentActiveCreditCard from '../creditCard/PaymentActiveCreditCard.tsx';
import PaymentActiveCob from '../PaymentActiveCob.tsx';


type PaymentActivePixCreditCardProps = {
  query: PaymentActivePixCreditCard_query;
  charge: PaymentActivePixCreditCard_charge$key;
};
const PaymentActivePixCreditCard = (
  props: PaymentActivePixCreditCardProps,
): ReactNode => {
  const { t } = useTranslation();

  const query = useFragment<PaymentActivePixCreditCard_query$key>(
    graphql`
      fragment PaymentActivePixCreditCard_query on Query {
        ...useGraphQLType_query
      }
    `,
    props.query,
  );

  const charge = useFragment<PaymentActivePixCreditCard_charge$key>(
    graphql`
      fragment PaymentActivePixCreditCard_charge on Charge {
        id
        brCode
        identifier
        company {
          nameFriendly
          logo {
            url(fitIn: true)
          }
          projectType
          taxID {
            taxID
          }
        }
        ...useChargePaymentMethod_charge
        ...PaymentActiveCreditCard_charge
        ...PaymentActiveCob_charge
      }
    `,
    props.charge,
  );

  const { isGraphQLMain } = useGraphQLType(query);
  const { pixCob } = useChargePaymentMethod(charge);

  // @todo pix active
  // @todo pix failed
  // @todo pix completed waiting credit card
  if (isGraphQLMain) {
    return <PaymentActiveCreditCard charge={charge} />;
  }

  return <PaymentActiveCob charge={charge} />;
};

export default PaymentActivePixCreditCard;
